// Generated by CoffeeScript 2.7.0
var Editor;

import RichTextEditor from 'trunks/vue/admin/components/libs/richtext_editor.js';

export default Editor = class Editor {
  constructor(element, options = {}) {
    var value;
    value = element.innerHTML;
    this.editor = new RichTextEditor({
      el: element,
      propsData: {...options, value}
    });
  }

};
